import { render, staticRenderFns } from "./settle-confirm.vue?vue&type=template&id=0dcaa7a9&scoped=true"
import script from "./settle-confirm.vue?vue&type=script&lang=js"
export * from "./settle-confirm.vue?vue&type=script&lang=js"
import style0 from "./settle-confirm.vue?vue&type=style&index=0&id=0dcaa7a9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcaa7a9",
  null
  
)

export default component.exports